// Central content + assets for the Türkiye Borsa Robotu landing page
export const IMAGES = {
  heroBuilding:
    "https://static.prod-images.emergentagent.com/jobs/51c86215-8d33-4aba-884f-9ea44ca7dad6/images/3bac37fdbdcf008ed9fe531c071c3264651e674fbe4f41823cea0d9085c07262.jpeg",
  heroSkyline:
    "https://images.unsplash.com/photo-1696711551721-458511adcd86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxJc3RhbmJ1bCUyMGNpdHklMjBza3lsaW5lJTIwYm9zcGhvcnVzfGVufDB8fHx8MTc4NjI3ODc1MXww&ixlib=rb-4.1.0&q=85",
  tradingScreen:
    "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxzdG9jayUyMG1hcmtldCUyMHRyYWRpbmclMjBjaGFydCUyMHNjcmVlbiUyMGZpbmFuY2V8ZW58MHx8fHwxNzg2Mjc4Njk0fDA&ixlib=rb-4.1.0&q=85",
  greenFuture:
    "https://images.unsplash.com/photo-1759508531671-ddb076f8c5b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxncmVlbiUyMHJlbmV3YWJsZSUyMGVuZXJneSUyMHRlY2hub2xvZ3klMjBmdXR1cmUlMjBjaXR5fGVufDB8fHx8MTc4NjI3ODY5NHww&ixlib=rb-4.1.0&q=85",
  handshake:
    "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGhhbmRzaGFrZSUyMGludmVzdG1lbnQlMjBncm93dGh8ZW58MHx8fHwxNzg2Mjc4NzUxfDA&ixlib=rb-4.1.0&q=85",
};

// Real training video uploaded by the owner.
export const VIDEO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_landing-tutorial-2/artifacts/m0bgskx5_sermayeai-tanitim-720.mp4";

export const NAV_LINKS = [
  { label: "Ana Sayfa", href: "#anasayfa" },
  { label: "Borsa Hakkında", href: "#hakkinda" },
  { label: "Piyasalar", href: "#piyasalar" },
  { label: "Yatırım Rehberi", href: "#rehber" },
  { label: "İstatistikler", href: "#istatistikler" },
  { label: "İletişim", href: "#iletisim" },
];

export const INSTRUMENTS = [
  { label: "Hisse Senetleri", icon: "LineChart" },
  { label: "Endeksler", icon: "BarChart2" },
  { label: "VİOP (Vadeli İşlem ve Opsiyon)", icon: "Layers" },
  { label: "Yatırım Fonları", icon: "Wallet" },
  { label: "Girişim Sermayesi Fonları", icon: "Users" },
  { label: "Gayrimenkul Sertifikaları", icon: "Landmark" },
  { label: "Borçlanma Araçları", icon: "FileText" },
];

export const TIMELINE = [
  { year: "1866", text: "Dersaadet Tahvil Borsası kuruldu." },
  { year: "1929", text: "Menkul Kıymetler ve Kambiyo Borsası Kanunu yürürlüğe girdi." },
  { year: "1985", text: "İstanbul Menkul Kıymetler Borsası (İMKB) faaliyete başladı." },
  { year: "2013", text: "Borsa İstanbul kuruldu ve tüm piyasalar tek çatı altında birleşti." },
  { year: "Bugün", text: "Yüzlerce halka açık şirket, milyonlarca yatırımcı ve trilyonlarca liralık piyasa değeriyle bölgenin en güçlü borsalarından biri." },
];

export const PULSE = [
  "500'den fazla halka açık şirket",
  "Milyonlarca aktif yatırımcı",
  "Her gün milyarlarca liralık işlem hacmi",
  "Dünyanın önde gelen gelişmekte olan piyasalarından biri",
  "Yerli ve yabancı yatırımcıların yoğun ilgisi",
];

export const WHY = [
  {
    icon: "TrendingUp",
    title: "Büyüyen Şirketlere Ortak Olursunuz",
    text: "Türkiye'nin en büyük şirketlerinin geleceğine ortak olabilirsiniz.",
  },
  {
    icon: "ShieldCheck",
    title: "Enflasyona Karşı Değer Koruma Potansiyeli",
    text: "Uzun vadede başarılı şirketler, yatırımcılara enflasyonun üzerinde getiri sağlayabilir.",
  },
  {
    icon: "Coins",
    title: "Düzenli Temettü Geliri",
    text: "Bazı şirketler elde ettikleri kârın bir kısmını yatırımcılarıyla paylaşır.",
  },
  {
    icon: "Smartphone",
    title: "Kolay Alım Satım",
    text: "Mobil uygulamalar sayesinde saniyeler içinde işlem yapılabilir.",
  },
  {
    icon: "Wallet",
    title: "Düşük Tutarlarla Başlangıç",
    text: "Büyük sermaye gerektirmeden yatırım yapılabilir.",
  },
];

export const STATS = [
  { value: 10, suffix: "+", label: "Ortalama Günlük İşlem Hacmi", unit: "Milyar ₺", icon: "BarChart3" },
  { value: 500, suffix: "+", label: "Halka Açık Şirket", unit: "", icon: "Building2" },
  { value: 8, suffix: " Milyon+", label: "Yerli Yatırımcı", unit: "", icon: "Users" },
  { value: 30, suffix: "'dan Fazla", label: "İşlem Gören Sektör", unit: "", icon: "PieChart" },
  { value: 100, suffix: "+", label: "BIST Endeksleri", unit: "Endeks", icon: "LineChart" },
];

export const BIST_DATA = [
  { t: "2019", v: 3250 },
  { t: "2019 Q3", v: 3520 },
  { t: "2020", v: 4180 },
  { t: "2020 Q2", v: 3480 },
  { t: "2020 Q4", v: 4620 },
  { t: "2021", v: 5100 },
  { t: "2021 Q3", v: 4820 },
  { t: "2022", v: 5480 },
  { t: "2022 Q2", v: 6400 },
  { t: "2022 Q4", v: 8100 },
  { t: "2023", v: 7620 },
  { t: "2023 Q2", v: 8450 },
  { t: "2023 Q4", v: 9200 },
  { t: "2024", v: 8980 },
  { t: "2024 Q2", v: 9760 },
  { t: "Bugün", v: 10245 },
];

export const CHECKLIST = [
  "Risk profilinizi belirleyin.",
  "Portföyünüzü çeşitlendirin.",
  "Uzun vadeli düşünün.",
  "Duygularla değil, analizlerle hareket edin.",
  "Güvenilir bilgi kaynaklarını takip edin.",
  "Bilinçli yatırım yapmayı ön planda tutun.",
];

export const DISCLAIMER =
  "Bu sayfada yer alan bilgiler yalnızca genel bilgilendirme amacıyla hazırlanmıştır. Finansal piyasalarda yapılan yatırımlar risk içerir ve geçmiş performans gelecekteki getirileri garanti etmez. Her yatırım kararı, kişisel risk tercihi ve finansal durum dikkate alınarak verilmelidir.";
